var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhanaflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC212D",
    d: "M32 5H4a4 4 0 0 0-4 4v5h36V9a4 4 0 0 0-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD116",
    d: "M15.423 22h5.185l-2.592-1.884zm3.587-4.941h3.215l-2.601 1.889l.991 3.052H36v-8H18.016zm-2.602 1.889l-2.601-1.889h3.215L18.016 14H0v8h15.416z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#288541",
    d: "M20.617 22.006L20.608 22h-5.186l-.009.006l.003-.006H0v5a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-5H20.615l.002.006z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.807 17.059l2.601 1.889L15.416 22l-.002.006l.009-.006l2.593-1.884L20.608 22l.009.006l-.002-.006l-.991-3.052l2.601-1.889H19.01L18.016 14l-.994 3.059z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhanaflag);
export default __webpack_public_path__ + "static/media/ghanaflag.ab8bcfb8fdfc947814026649e9eb6f09.svg";
export { ForwardRef as ReactComponent };